import { colorStrings } from "@iewccouk/Utilities/variables";
import { shippingAddressStyles as styles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.oneTimeAddressCheckbox = {
    ...styles.oneTimeAddressCheckbox,
    css: css`
        &&& {
            label {
                color: ${getColor(colorStrings.commonGlobalGray02)} !important;
            }
        }
    `,
};
